import { render } from "./Vacuna.vue?vue&type=template&id=f5b277d8&scoped=true"
import script from "./Vacuna.vue?vue&type=script&lang=js"
export * from "./Vacuna.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=f5b277d8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b277d8"]])

export default __exports__